import React from 'react';
import { Link } from 'react-router-dom';

const UpgradeBanner = ({ message }) => {
	if (!message) return null;
	return (
		<div
			style={{
				background: '#111113',
				color: '#fff',
				borderRadius: '16px',
				padding: '16px 18px',
				display: 'flex',
				flexWrap: 'wrap',
				gap: '12px',
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: '16px',
			}}
		>
			<span>{message}</span>
			<Link to="/pricing" style={{ color: '#fff', fontWeight: 700 }}>
				Upgrade
			</Link>
		</div>
	);
};

export default UpgradeBanner;
